export default __webpack_public_path__ + "static/media/empty-product.91aed243.png";